export function round (value) {
  return Math.round(value);
}
